export default {
  agenda: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/schedule/resources/props.js